import { useCallback, useMemo, useState } from 'react';
import { useBootstrapper } from '@/ui-kit/contexts/BootstrapperContext';

type State = 'idle' | 'ready' | 'loading';

type Value = {
  state: State;
  link: string | undefined;
  requestLink: () => Promise<void>;
  reset: () => void;
};

export const useGetShareLink = () => {
  const { bootstrapper } = useBootstrapper();

  const [state, setState] = useState<State>('idle');
  const [link, setLink] = useState<string | undefined>();

  const reset = useCallback(() => {
    setState('idle');
    setLink(undefined);
  }, []);

  const requestLink = useCallback(async () => {
    if (!bootstrapper) {
      return;
    }

    setState('loading');
    try {
      const link = await bootstrapper.createLink();

      setLink(link);
      setState('ready');
    } catch (error) {
      console.error('Failed to copy:', error);
      setState('idle');
    }
  }, [bootstrapper]);

  return useMemo<Value>(
    () => ({
      state,
      link,
      requestLink,
      reset,
    }),
    [state, link, requestLink, reset],
  );
};
